import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/Button';
interface ReflexologyChartsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ReflexologyChartsModal({
  isOpen,
  onClose
}: ReflexologyChartsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 print:hidden" data-id="element-593">
      <div className="bg-white rounded-2xl shadow-2xl max-w-7xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-594">
        {/* Header */}
        <div className="bg-gradient-to-r from-amber-600 to-orange-600 text-white px-6 py-4 flex items-center justify-between" data-id="element-595">
          <h2 className="text-2xl font-bold" data-id="element-596">Reflexology Charts</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-lg transition-colors" data-id="element-597">
            <X className="w-6 h-6" data-id="element-598" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-599">
          <div className="space-y-6" data-id="element-600">
            {/* Hand Reflexology Chart */}
            <div data-id="element-601">
              <h3 className="text-lg font-bold text-amber-900 mb-3" data-id="element-602">
                Hand Reflexology Points
              </h3>
              <img src="https://cdn.magicpatterns.com/uploads/k9qNQyrcEQXgFEsQ4rUdgd/image.png" alt="Hand Reflexology Chart showing pressure points on both palms" className="w-full h-auto rounded-lg border-2 border-amber-200 shadow-lg" data-id="element-603" />
            </div>

            {/* Foot Reflexology Chart */}
            <div data-id="element-604">
              <h3 className="text-lg font-bold text-amber-900 mb-3" data-id="element-605">
                Foot Reflexology Points
              </h3>
              <img src="https://cdn.magicpatterns.com/uploads/84cAa2tfEex6DD1CTENWm1/image.png" alt="Foot Reflexology Chart showing pressure points on both feet" className="w-full h-auto rounded-lg border-2 border-amber-200 shadow-lg" data-id="element-606" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-amber-200 px-6 py-4 bg-amber-50" data-id="element-607">
          <Button onClick={onClose} className="w-full" data-id="element-608">
            Close
          </Button>
        </div>
      </div>
    </div>;
}